import React, { useContext, useEffect } from 'react';
import "./Dashboard.css";
import mainContext from '../../contexts/mainContext.jsx';
import styled from '@emotion/styled';
import DashBoardCard from './DashBoardCard';
import { getDashBoardAnalyticsController } from '../../Controllers/DashBoard';
import Barchart from './Barchart';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import JobsCard from './JobsCard';
import { useNavigate } from 'react-router-dom';
import DisputeCard from "./DisputeCard"

const Dashboard = () => {
  const navigate = useNavigate()
  const context = useContext(mainContext)
    let { setProfileNavTitle, setPageload } = context;
  const [dashBoardData, setDashBoardData] = React.useState({
    users: [],

    houseKeeper: {},
    concierge: {},
    babySitter: {},
    admin: {},
    manager: {},
    customer: {},

    jobBooking: [],
    wallet: [],
    payout: [],
    totalUser: 0,
    lastMonthUser: 0,
    disputes: {
      total: 0,
      pending: 0,
      resolved: 0,
      rejected: 0,
    },
  })

  const getDashBoardAnalytics = async () => {
    setPageload(true)
    const res = await getDashBoardAnalyticsController()
    setPageload(false)
    if (res && res.status === 500) {
      return alert("Internal server error")
    }
    if (res.data.status !== 200) {
      return alert(res.data.errors[0].message)
    }
    let totalUser = 0,
      lastMonthUser = 0,
      houseKeeper = {},
      concierge = {},
      babySitter = {},
      admin = {},
      manager = {},
      customer = {}
    res.data.data.users.forEach((obj) => {
      totalUser = totalUser + obj.total
      lastMonthUser = lastMonthUser + obj.lastMonth
      if (obj.role === "HouseKeeper") houseKeeper = obj
      else if (obj.role === "Concierge") concierge = obj
      else if (obj.role === "Admin") admin = obj
      else if (obj.role === "Manager") manager = obj
      else if (obj.role === "BabySitter") babySitter = obj
      else if (obj.role === "Seeker") customer = obj
    })
    setDashBoardData({
      ...dashBoardData,
      ...res.data.data,
      houseKeeper,
      concierge,
      admin,
      manager,
      babySitter,
      customer,
      lastMonthUser,
      totalUser,
    })
  }

  useEffect(() => {
    getDashBoardAnalytics()
    setProfileNavTitle("DASHBOARD")
    // eslint-disable-next-line
  }, [])

  const getUserInfo = (key) => {
    let response = {},
      find = false
    dashBoardData.users.some((obj) => {
      if (obj.role === key) {
        find = true
        response = obj
      }
      return find
    })
    return response
  }

  return (
    <React.Fragment>
      {Object.keys(dashBoardData).length > 0 ? (
        <Container>
          <FisrtSection>
            <DashBoardCard
              title={"Total App Users"}
              totalUsers={dashBoardData.totalUser}
              percentage={((dashBoardData.totalUser - dashBoardData.lastMonthUser) * 100) / dashBoardData.lastMonthUser}
            />
            <DashBoardCard
              title={"Total Customers"}
              totalUsers={dashBoardData?.customer?.total}
              percentage={
                ((dashBoardData?.customer?.total - dashBoardData?.customer?.lastMonth) * 100) /
                dashBoardData?.customer?.lastMonth
              }
              onClick={() => navigate("/users/seekers-listing")}
            />
            <DashBoardCard
              title={"Total Babysitters"}
              totalUsers={dashBoardData?.babySitter?.total}
              percentage={
                ((dashBoardData?.babySitter?.total - dashBoardData?.babySitter?.lastMonth) * 100) /
                dashBoardData?.babySitter?.lastMonth
              }
              onClick={() => navigate("/users/baby-sitters-listing")}
            />
            <DashBoardCard
              title={"Total Housekeepers"}
              totalUsers={dashBoardData?.houseKeeper?.total}
              percentage={
                ((dashBoardData?.houseKeeper?.total - dashBoardData?.houseKeeper?.lastMonth) * 100) /
                dashBoardData?.houseKeeper?.lastMonth
              }
              onClick={() => navigate("/users/house-keepers-listing")}
            />
            <DashBoardCard
              title={"Total Managers"}
              totalUsers={dashBoardData?.manager?.total}
              percentage={
                ((dashBoardData?.manager?.total - dashBoardData?.manager?.lastMonth) * 100) /
                dashBoardData?.manager?.lastMonth
              }
            />

            {/* Dispute Card */}
            <DisputeCard disputes={dashBoardData.disputes} onClick={() => navigate("/payments/disputes")} />

            {dashBoardData.jobBooking.length > 0 && <JobsCard type="Job" jobsBooking={dashBoardData.jobBooking} />}
            {dashBoardData.jobBooking.length > 0 && <JobsCard type="Booking" jobsBooking={dashBoardData.jobBooking} />}
            <DashBoardCard title={"Total Job Amount"} totalUsers={"€ " + dashBoardData?.wallet[0]?.totalJobAmount} />
            <DashBoardCard
              title={"Total Payment Received"}
              totalUsers={"€ " + dashBoardData?.wallet[0]?.totalPaymentReceived}
            />
            <DashBoardCard
              title={"Total Pending Payment"}
              totalUsers={"€ " + dashBoardData?.wallet[0]?.totalPendingPayment}
            />
            <DashBoardCard
              title={"Total Nona Earning"}
              totalUsers={"€ " + dashBoardData?.wallet[0]?.totalNonaEarning}
            />
          </FisrtSection>
          <SecondSection>
            <div>
              <Barchart />
            </div>
          </SecondSection>
        </Container>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: "3rem" }}>
            <CircularProgress />
          </Box>
        </>
      )}
    </React.Fragment>
  )
}

const Container = styled("div")`
    width: 100%;
    margin-top: 2rem;
`

const FisrtSection = styled("div")`
    display: flex;
    flex-wrap: wrap;
    column-gap: 2rem;
    row-gap: 1rem;
`

const SecondSection = styled("div")`
    margin-top: 3rem;
    display: grid;
    column-gap: 2rem;
    grid-template-columns: 2fr 1.4fr;
`

const GlobalUsers = styled("div")`
    box-shadow: rgba(149, 157, 165, 0.3) 0px 8px 24px;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    .header{
        font-weight: 600;
    }
    small{
        color: var( --nona-light-blue);
    }
    img{
        height: 30px;
        width: 30px;
    }
    .footer{
        display: block;
        text-align: center;
        font-size: 80%;
        cursor: pointer;
        color: var(--nona-light-blue);
    }
`

export default Dashboard
